var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M277.333 384H106.667C93.8667 384 85.3334 375.467 85.3334 362.667C85.3334 349.867 93.8667 341.333 106.667 341.333H277.333C290.133 341.333 298.667 349.867 298.667 362.667C298.667 375.467 290.133 384 277.333 384ZM405.333 277.333H106.667C93.8667 277.333 85.3334 268.8 85.3334 256C85.3334 243.2 93.8667 234.667 106.667 234.667H405.333C418.133 234.667 426.667 243.2 426.667 256C426.667 268.8 418.133 277.333 405.333 277.333ZM405.333 170.667H234.667C221.867 170.667 213.333 162.133 213.333 149.333C213.333 136.533 221.867 128 234.667 128H405.333C418.133 128 426.667 136.533 426.667 149.333C426.667 162.133 418.133 170.667 405.333 170.667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.c8214ed111e9c6a0c891b9e9b1b84168.svg";
export { ForwardRef as ReactComponent };